'use client';

import React, { useEffect, useState } from 'react';
import { TrendingUp, Layers } from 'lucide-react';
import { createClient } from '@/lib/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface KPIData {
  totalReports: number;
  loading: boolean;
  error: string | null;
}

export default function DashboardKPIGrid() {
  const { user } = useAuth();
  const [kpiData, setKpiData] = useState<KPIData>({ totalReports: 0, loading: true, error: null });

  useEffect(() => {
    if (!user) {
      setKpiData({ totalReports: 0, loading: false, error: null });
      return;
    }

    const fetchKPIs = async () => {
      try {
        const supabase = createClient();
        const { count, error } = await supabase
          .from('reports')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);

        if (error) throw error;
        setKpiData({ totalReports: count ?? 0, loading: false, error: null });
      } catch (err: any) {
        setKpiData({ totalReports: 0, loading: false, error: err.message });
      }
    };

    fetchKPIs();
  }, [user]);

  const totalValue = kpiData.loading ? '—' : String(kpiData.totalReports);

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-6 gap-3">
      {/* Total Reports — dynamic, hero card */}
      <div className="punk-card p-4 bg-accent/5 border-accent col-span-2 md:col-span-2 fade-in">
        <div className="flex items-center justify-between mb-3">
          <span className="text-accent"><Layers size={16} /></span>
          <TrendingUp size={13} className="text-green-400" />
        </div>
        <div className="metric-value text-4xl text-accent">
          {kpiData.loading ? (
            <span className="inline-block w-12 h-8 bg-accent/10 rounded animate-pulse" />
          ) : (
            totalValue
          )}
        </div>
        <div className="metric-label mt-2">Total Reports</div>
        <div className="text-xs mt-1 mono text-accent">
          {kpiData.loading ? '' : kpiData.error ? 'Fehler beim Laden' : 'Alle deine Berichte'}
        </div>
      </div>
    </div>
  );
}